import React, { useState, useEffect, useRef } from 'react';
import {
  Card,
  CardContent,
  TextField,
  Button,
  Grid,
  Checkbox,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  CircularProgress,
  MenuItem,
} from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import SessionStorageService from '../../../services/StorageService';
import AbonelerAPI from '../../../apis/OB/Get/AbonelerAPI';
import EndeksBildirimSave, { EndeksBasvuruSaveRequest } from '../../../apis/OB/SaveApi/EndeksBildirimSave';
import BilgilendirmePopup from '../../../components/OB/popups/BilgilendirmePopUp';
import AciklamaAndUserControlPopup from '../../../components/OB/popups/aciklama-usercontrol-popup';
import { changeDateFormat } from '../../../helpers/DateFormat';
import { displayValue } from '../../../helpers/TodayDate';
import EndeksListe from '../../../apis/OB/Get/EndeksListe';
import AboneListeAPI from '../../../apis/OB/Get/AboneListeAPI';
import AboneSicilListeAPI from '../../../apis/OB/Get/AboneSicilListeAPI';
import Recaptcha from "../../../components/Recaptcha";
import { toast } from "react-toastify";

const EndeksBildirim: React.FC = () => {
  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);

  const [data, setData] = useState<any[]>([]);
  const [aboneData, setAboneData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [checkedIndex, setCheckedIndex] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false);
  const [popupContent, setPopupContent] = useState<string>('');
  const [isLoad, setIsLoad] = useState<boolean>(true);
  const [userControlPopup, setUserControlPopup] = useState<boolean>(false);
  const [popupAciklama, setPopupAciklama] = useState<string>('');
  const [kayitBasarili, setKayitBasarili] = useState<boolean>(false);
  const [aciklamaPopUpVisible, setAciklamaPopUpVisible] = useState<boolean>(false);

  const navigate = useNavigate();
  const user = SessionStorageService.getUserInfo();

  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate('/login');
  };

  useEffect(() => {
    if (user == null) {
      setUserControlPopup(true);
    } else {
      setIsLoad(false);
      fetchAboneData();
      fetchData(-1);
    }
  }, []);

  const fetchAboneData = async () => {
    try {
      const res = await AbonelerAPI.getAbonelerListe(2,user?.sicilKodu);
      setAboneData(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchData = async (aboneNo: number) => {

    setIsLoading(true);
    try {
      const res = await EndeksListe.getEndeksListe(
        user?.sicilKodu,
        aboneNo === -1 ? undefined : aboneNo
      );
      if (res.data.length > 0) {
        setData(res.data);
      } else {
        openPopup(
          'Sayaçınız henüz okunmamıştır. Sayaçınız okunduktan sonra giriş yapabilirsiniz.'
        );
      }
    } catch (err) {
      console.error(err);
    }
    setIsLoading(false);
  };

  const handleDeleteAll = () => {
    formik.setFieldValue('aboneNo', -1);
    fetchData(-1);
  };

  const openPopup = (content: string) => {
    setPopupContent(content);
    setAciklamaPopUpVisible(true);
  };

  const closePopup = () => {
    setPopupContent('');
    setAciklamaPopUpVisible(false);
    setIsPopupVisible(false); // Bu durum doğru değişmeli
    if (kayitBasarili) {
      setCheckedIndex(null);
      formik.resetForm();
    }
  };


  const formik = useFormik({
    initialValues: {
      aboneNo: -1,
      sonEndeks: '',
    },
    validationSchema: Yup.object({
      aboneNo: Yup.number(),
      sonEndeks: Yup.number()
        .required('Son endeks giriniz')
        .min(0, 'Son endeks negatif olamaz'),
    }),
    onSubmit: async (values) => {

      if (checkedIndex === null) {
        openPopup('Lütfen bir abonelik seçiniz.');
        return;
      }
      // reCAPTCHA’yı tetikle
      const token = await recaptchaRef.current?.handleSubmit();
      if (!token) {
        toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
        return;
      }

      const request = new EndeksBasvuruSaveRequest(
        303,
        user?.sicilKodu,
        checkedIndex,
        Number(values.sonEndeks),
        token
      );
      EndeksBildirimSave.saveEndeksBildirimBasvuruSave(request)
        .then((res) => {
          if (res.data.sonuc === 0) {
            let basvuruNo = res.data.basvuruNo;
            setPopupAciklama(
              'İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: ' + basvuruNo
            );
            setKayitBasarili(true);
          } else {
            setPopupAciklama(res.data.sonucAciklama);
          }
        })
        .catch((err: any) => {
          console.error(err);
          setPopupAciklama(
            'İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error).'
          );
        })
        .finally(() => {
          setIsPopupVisible(true);
          recaptchaRef.current?.reset();
        });
    },
  });

  const handleChangePage = (event: unknown, newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  return isLoad ? (
    <>
      <div className="d-flex align-self-stretch justify-content-center align-items-center">
        <CircularProgress />
      </div>
      {userControlPopup && (
        <AciklamaAndUserControlPopup
          open={userControlPopup}
          handleClose={closeUserControlPopup}
          isUserControlPopUp={true}
          description={'Bu sayfayı kullanmak için giriş yapmalısınız.'}
        />
      )}
    </>
  ) : (
    <>
      <Card>
        <CardContent>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={8}>
                <TextField
                  size="small"
                  select
                  fullWidth
                  label="Abone No"
                  value={formik.values.aboneNo}
                  onChange={(e) => {
                    const selected = Number(e.target.value);
                    formik.setFieldValue('aboneNo', selected);
                    fetchData(selected);
                  }}
                  onBlur={formik.handleBlur}
                  name="aboneNo"
                >
                  <MenuItem value={-1}>Abone No</MenuItem>
                  {aboneData.map((item, index) => (
                    <MenuItem key={index} value={item.aboneNo}>
                      {item.aboneNo}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                xs={12}
                sm={4}
                container
                spacing={2}
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item>
                  <Button variant="contained" onClick={() => fetchData(formik.values.aboneNo)}>
                    Ara
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="contained" onClick={handleDeleteAll}>
                    Temizle
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {isLoading ? (
                  <Typography>Yükleniyor...</Typography>
                ) : (
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>Abone No</TableCell>
                          <TableCell>Sayaç No</TableCell>
                          <TableCell>Adres</TableCell>
                          <TableCell>Son Okuma Durumu</TableCell>
                          <TableCell>Son Okuma Tarihi</TableCell>
                          <TableCell>Son Endeks</TableCell>
                          <TableCell>Ortalama</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.length > 0 ? (
                          data
                            .slice(
                              currentPage * rowsPerPage,
                              currentPage * rowsPerPage + rowsPerPage
                            )
                            .map((item, index) => (
                              <TableRow key={index}>
                                <TableCell>
                                  <Checkbox
                                    checked={checkedIndex === Number(item.aboneNo)}
                                    onChange={() => setCheckedIndex(Number(item.aboneNo))}
                                  />
                                </TableCell>
                                <TableCell>{displayValue(item.aboneNo)}</TableCell>
                                <TableCell>{displayValue(item.sayacNo)}</TableCell>
                                <TableCell>{displayValue(item.adres)}</TableCell>
                                <TableCell>{displayValue(item.sonOkumaDurumuAciklama)}</TableCell>
                                <TableCell>
                                  {displayValue(changeDateFormat(item.sonOkumaTarihi))}
                                </TableCell>
                                <TableCell>{displayValue(item.sonEndeks)}</TableCell>
                                <TableCell>{displayValue(item.ortalama)}</TableCell>
                              </TableRow>
                            ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={8}>Veri bulunamadı!</TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={data.length}
                      rowsPerPage={rowsPerPage}
                      page={currentPage}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                )}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6">
                  Lütfen endeks bildirimi yapmak istediğiniz son endeks bilgisini giriniz
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  size="small"
                  fullWidth
                  label="Son Endeks"
                  name="sonEndeks"
                  type="number"
                  value={formik.values.sonEndeks}
                  onChange={formik.handleChange}
                  error={formik.touched.sonEndeks && Boolean(formik.errors.sonEndeks)}
                  helperText={formik.touched.sonEndeks && formik.errors.sonEndeks}
                />
              </Grid>
              <Grid item xs={12} className="d-flex justify-content-end">
                <Recaptcha
                  ref={recaptchaRef}
                  changeHandleRecaptcha={setRecaptchaPassed}
                />
                <Button variant="contained" color="primary" type="submit">
                  Gönder
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
      {isPopupVisible && (
        <BilgilendirmePopup
          basvuruTuruId={-5}
          isSorunBildirPopup={!kayitBasarili}
          closePopup={closePopup}
          open={isPopupVisible}
          editDescription={popupAciklama}
        />
      )}
      {aciklamaPopUpVisible && (
        <AciklamaAndUserControlPopup
          open={aciklamaPopUpVisible}
          handleClose={closePopup}
          isUserControlPopUp={false}
          description={popupContent}
        />
      )}
    </>
  );
};

export default EndeksBildirim;
